export default __webpack_public_path__ + "static/media/79.192c59e5.jpg";